import { LSK } from '@shared/utils/storage/config';
import logger from '@shared/utils/error/logger';
import { LOGGER_SPACIAL_SYMBOL } from '@shared/utils/error/config';
import type { GenerateLocation, ResolutionTrackType } from '@/handler/event/impl/action';
import type { TrackObjectType } from '../newDataWareHose/types';
import { PayFor } from '../newDataWareHose/event/payment';
import { Page } from '@/handler/cache/enum';
function isValidAppSid(id?: string) {
	return id && id.length >= 4 && id.length <= 6 && id.match(/\d/) && id.match(/\w/);
}

export const initBasePage = () => {
	const url = location.pathname;
	// 落地页检查
	if (url.match(/\/post\/.+/)) return 'post_landing_page';
	if (url.match(/\/user\/.+/)) return 'profile';
	if (url.match(/\/search/)) return 'search_result';
	if (url.match(/\/tag\/.+/)) return 'topic';
	if (url.match(/\/tag-app\/.+/)) return 'topic_app';
	if (url.match(/\/i\/.+/)) return 'image';
	if (url.match(/\/faceswap\/.+/)) return 'faceswap_detail';
	if (isValidAppSid(url.split('/')[0]) || isValidAppSid(url.split('/')[1])) return 'creator_detail';
	return 'home';
};

export const landingOrigin = () => {
	const source = new URLSearchParams(location.search).get('source');
	return source == 'share' ? source : 'none';
};

export const parseTaskRoute = () => {
	const { location1 } = trackRecorder.source;
	return location1 ? `/${location1}/task` : '/task';
};

type TaskInfo = {
	imgIds?: string[];
	app_id?: string;
	short_id?: string;
	generate_wait_time?: number;
	ability_name?: string;
	user_scene?: string;
	location?: string;
	location1: string;
	location2: string;
	tag_id: string;
	generateLocation?: typeof GenerateLocation;
	generateInPost?: string;
	generateInGallery?: string;
	generatePlace?: T_GeneratePlace;
	isRegenerate?: string;
	enhancementLocation?: string;
	generateAbilityName?: string;
	generateEstimateTime?: string;
	generateStartTime?: number;
	generateCompletionTime?: string;
	object_type?: TrackObjectType;
	image_type: string;
	is_slide_view?: string;
	first_view?: boolean;
	sort?: number;
	trace_info?: string;
	commend_label?: string;
	app_source?: string;
	resolution_detail?: ResolutionTrackType; // 结果页调视频高清的原子能力 & a1应用详情页直接加了高清分辨率参数的生成 都需要加这个参数.用于看各种分辨率生成成功的情况
	chatbot_id?: string;
	credit?: number;
	multiple?: number;
	bond_level?: number;
	scenario?: string;
};

export type T_GeneratePlace =
	| 'detail'
	| 'direct'
	| 'half-direct'
	| 'comment'
	| 'direct_generate'
	| 'result_show'
	| '';

export type ChatbotInfoSource =
	| 'filter_page_tips'
	| 'result_page_tips'
	| 'result_page_chat'
	| 'message_tab_tip'
	| 'list_new'
	| 'list_more';

class Recorder {
	// 记录其他字段
	data = {
		login: '', // no login register // 用来记录关闭登陆弹窗的埋点发送了没有，避免重复发送
	} as Record<string, string>;

	// URL/组件位置 记录
	source = {
		/** 一般情况下是 首页，如果是其他落地页，这个最先初始化 */
		basePage: 'none' as
			| 'home'
			| 'post_landing_page'
			| 'search_result'
			| 'topic'
			| 'topic_app'
			| 'profile'
			| 'image'
			| 'creator_detail'
			| 'faceswap_detail',

		/** 如果 basePage是 home，那么tabPage值有效 */
		tabPage: '' as Page,

		location: '',
		location1: '',
		location2: '',

		no_app_visit: false,

		post: '', // 打开Post前位于
		post_origin: 'search_result',
		login: '', // 打开登陆弹窗的原因
		withShare: false, // 链接中有分享信息
		loginHasReported: false, // 登陆弹窗是否已经发送埋点

		// TODO 下面这几个字段在多任务的时候就错了，需要移动到下面task字段去存
		// FIXME: 但是存的时候还不知道任务id，所以暂时先这样
		generateLocation: '' as typeof GenerateLocation,
		generateInPost: '',
		generateInGallery: '',
		generatePlace: '' as T_GeneratePlace,
		isRegenerate: '' as 'create' | 'recreate',
		enhancementLocation: '',
		generateAbilityName: '',

		// 从鼠标元素范围获取的labelId，准！
		labelId: '' as string | undefined,
		labelName: '' as string | undefined,
		// 从Studio页面进去的app需要这个
		galleryId: '' as string | undefined,
		commend_label: '', //	推荐app的来源是recommend 还是hot
		app_source: '', // app来源
		chatbot_id: '',
		function_type: '' as PayFor,
	};

	first_view = '';
	sort = '';
	trace_info = '';

	lastTraceId = '';
	task = {} as Record<string, TaskInfo>;
	shareInfo = {
		type: '',
		shareOrigin: '',
		creator: '',
		button_detail: '',
		app_id: '',
		image_id: '',
		post_id: '',
		topic_id: '',
		is_poster: '',
	};

	searchInfo = {
		keyword_en: '',
	};

	purchaseInfo = {
		app_id: '',
		short_id: '',
		ability_name: '',
		tag_id: '',
		user_scene: '',
		entry_point: '',
	};

	allTagAppList = [] as string[];

	allTagPostList = [] as string[];

	chatbotInfo = {
		type: '' as 'pgc' | 'ugc',
		chatbot_type: '' as 'pgc' | 'ugc',
		sort: null as number | null,
		source: '' as ChatbotInfoSource,
		is_recall: null as boolean | null,
		app_id: '',
		chatbot_id: '',
		persona_id: '',
		persona_type: '',
	};
	chatbotNewList = [] as string[];
	chatbotMoreList = [] as string[];
	// 需要用localStorage存住的数据
	localRecord = {
		// 有几个字段是记住最近24小时访问的来着
	};

	cooldown = new Set<string>();
	constructor() {
		// 落地位置检查
		this.source.basePage = initBasePage();
		this.source.withShare = landingOrigin() == 'share';
		// 从localStorage中读取数据
		try {
			const task = localStorage.getItem(LSK.TRACK_RECORDER_TASK);
			if (task) {
				const taskData = JSON.parse(task);
				const saveTaskKeys = Object.keys(taskData)
					.sort(
						(a, b) => (taskData[a].generateStartTime || 0) - (taskData[b].generateStartTime || 0),
					)
					.slice(0, 3000);

				this.task = saveTaskKeys.reduce(
					(acc, key) => {
						acc[key] = taskData[key];
						return acc;
					},
					{} as Record<string, TaskInfo>,
				);
			}
		} catch (error) {
			// 捕获读取存储时的错误（包括存储超限等情况）
			if (
				error instanceof DOMException &&
				(error.name === 'QuotaExceededError' || error.code === 22)
			) {
				logger.error(
					LOGGER_SPACIAL_SYMBOL.EVENT_LOGGER,
					'localStorage quota exceeded when reading task',
					error,
				);
			} else {
				logger.error(
					LOGGER_SPACIAL_SYMBOL.EVENT_LOGGER,
					'error reading task from localStorage',
					error,
				);
			}
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	saveLocal(key: string, value: string, timeout?: number) {}

	setTask(taskId: string, taskInfo: Partial<TaskInfo>) {
		try {
			const originData = this.task[taskId] || {};
			this.task[taskId] = {
				...originData,
				...taskInfo,
			};
			localStorage.setItem(LSK.TRACK_RECORDER_TASK, JSON.stringify(this.task));
		} catch (error) {
			// 捕获存储超限错误
			if (
				error instanceof DOMException &&
				(error.name === 'QuotaExceededError' || error.code === 22)
			) {
				// 可选：清理旧数据以释放空间
				try {
					const saveTaskKeys = Object.keys(this.task)
						.sort(
							(a, b) =>
								(this.task[a].generateStartTime || 0) - (this.task[b].generateStartTime || 0),
						)
						.slice(0, 3000);

					this.task = saveTaskKeys.reduce(
						(acc, key) => {
							acc[key] = this.task[key];
							return acc;
						},
						{} as Record<string, TaskInfo>,
					);

					localStorage.setItem(LSK.TRACK_RECORDER_TASK, JSON.stringify(this.task));
				} catch (retryError) {
					// 如果重试仍然失败，记录错误但不抛出
					logger.error(
						LOGGER_SPACIAL_SYMBOL.EVENT_LOGGER,
						'failed to clear old task data after quota exceeded',
						retryError,
					);
				}
			} else {
				// 其他类型的错误也记录
				logger.error(
					LOGGER_SPACIAL_SYMBOL.EVENT_LOGGER,
					'error saving task to localStorage',
					error,
				);
			}
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	saveLocalIfTimeout(key: string, value: string, timeout?: string) {}

	saveOneTime(key: string, value: string) {
		// if (this.data[key]) logger.error('埋点', '不严谨的传递数据get', { key, value: this.data[key] });
		this.data[key] = value;
	}
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	getLocal(key: string, defaultValue?: string) {}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	getLocalWithSave(key: string, defaultValue?: string) {}

	getAppVisitIndex(app_id: string) {
		const firstView = this.allTagAppList.slice(0, 4).includes(app_id);
		const sort = this.allTagAppList.findIndex((item) => item === app_id);
		if (sort === -1) return {};
		return { firstView, sort: sort + 1 };
	}

	getPostVisitIndex(post_id: string) {
		const firstView = this.allTagPostList.slice(0, 4).includes(post_id);
		const sort = this.allTagPostList.findIndex((item) => item === post_id);
		if (sort === -1) return {};
		return { firstView, sort: sort + 1 };
	}

	getChatbotVisitIndex(id: string, type: 'new' | 'more') {
		const list = type === 'new' ? this.chatbotNewList : this.chatbotMoreList;
		const sort = list.findIndex((item) => item === id);
		if (sort === -1) return { sort: -1 };
		return { sort: sort + 1 };
	}

	getOneTime(key: string) {
		if (this.data[key]) {
			const value = this.data[key];
			this.data[key] = undefined as any;
			return value;
		} else {
			return '';
		}
	}
}

export const trackRecorder = new Recorder();
// @ts-expect-error debug
window.debugTrack = trackRecorder;
